import script from "./header-segmented-survey.vue?vue&type=script&setup=true&lang=js"
export * from "./header-segmented-survey.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__